import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { v4 as uuidv4 } from 'uuid';

import 'react-loading-skeleton/dist/skeleton.css';

const ButtonLoader = ({ count, width, height }) => (
  <>
    {Array.from({ length: count }).map(() => (
      <Skeleton key={uuidv4()} borderRadius={6} width={width} height={height} />
    ))}
  </>
);

export default ButtonLoader;
